'use client';

import {styled} from "@mui/system";
import {Typography} from "@mui/material";

const ArchiveTitleText = styled(Typography)(({theme}) => ({
    fontSize: '1.25rem !important',
    textTransform: 'capitalize',
    margin: '0',
    color: `${theme.palette.text.primary} !important`
}));

export default ArchiveTitleText;
